import commonResources from '@/common/resources/common';
import { FormattedMessage } from 'react-intl';
import { MenuItemDto } from '@emutabakat-types/app';
import React from 'react';

const musteriMenuItems: MenuItemDto[] = [
  {
    key: '0',
    icon: 'file-done',
    title: <FormattedMessage id={commonResources.cariHesaplar.id} />,
    url: '/carihesap/1'
  },
  {
    key: '1',
    icon: 'file-done',
    title: 'BA/BS',
    url: '/carihesap/2'
  }
];

export default musteriMenuItems;
